module.exports = __webpack_public_path__ + "b5e860880d26ceec47fa2e11fa6d31ca.svg";